import { TRACK_IDS } from "../../analytics/trackIds";
import React from "react";
import localization from "../../statics/localization";
import { isPayableOffer, offerPrice, rentalCopy } from "../../api/mw/rental";

export default function RentalOptions({ content, onSelect, disabled = false }) {
  const copy = rentalCopy();
  return (
    <div className="vod-rental-options" role="group" aria-label={copy.choose}>
      {(content?.products || []).filter(isPayableOffer).map((offer) => (
        <button
          type="button"
          data-track-id={offer.type === "PURCHASE" ? TRACK_IDS.DETAIL_BUY : TRACK_IDS.DETAIL_RENT}
          className="rent-button"
          disabled={disabled}
          key={offer.id}
          onClick={() => onSelect(content, offer)}
        >
          {offer.type === "PURCHASE" ? localization.payment.purchase : localization.rentVod}: {offerPrice(offer)}
          {offer.type === "RENTAL" && ` · ${offer.duration} ${copy.days}`}
        </button>
      ))}
    </div>
  );
}
